/**
 * THE DOORS TO THE OTHER SYSTEMS (the owner, 2026-10-17: "add links to growth and all other systems
 * for owners and managers to oversight from the ops like the phone wall").
 *
 * Each door is a page another system of ours serves behind its own sign-in: the phone system's wall
 * and records, growth's control panel, the website's leads screens. Ops links to each and holds
 * nothing of it (isolation rule 4: no cross-system binding, and a link is not one). The list is
 * `SYSTEM_LINKS` in `wrangler.jsonc`, one per environment, and `GET /api/me` hands it to the roles
 * below and to nobody else; the top bar draws what it is handed, which is UX and not the control.
 */
import type { Role } from './enums.ts';

/** One door, as `wrangler.jsonc` writes it and `GET /api/me` hands it on. */
export interface SystemLink {
  /** Which door this is, a word that never changes: `phone-wall`, `growth`, `leads-records`. */
  readonly key: string;
  /** The word on the door. */
  readonly label: string;
  /** Where it leads, https on a host of ours. Empty in the config means not open yet. */
  readonly href: string;
  /** What is behind it in one sentence, then "Opens in a new tab." Shown on hover. */
  readonly hint: string;
}

/**
 * WHO IS HANDED THE DOORS: an owner or a manager, the two who oversee the business from ops (the
 * owner, 2026-10-17). The office keeps the Call wall door it has always had and is handed no list;
 * a cleaner is handed nothing. A list and never a CHECK: `api/src/routes/me.ts` holds it.
 */
export const SYSTEM_LINK_ROLES = Object.freeze([
  'owner',
  'manager',
] as const) satisfies readonly Role[];

/** Whether this role is handed the doors, as the server decides it. */
export const maySeeSystems = (role: Role): boolean =>
  (SYSTEM_LINK_ROLES as readonly Role[]).includes(role);

/** The key the phone system's wall is under, which the top bar draws as its own door. */
export const CALL_WALL_KEY = 'phone-wall';
